// extracted by css-extract-rspack-plugin
export default {"content":"ErpInitialView_content__m5BEw","center":"ErpInitialView_center__s6Krm"};